import React, { useState } from 'react';
import { IconButton, Menu, ListItemIcon } from '@mui/material';
import {
	MoreVertRounded,
	DownloadRounded,
	EditNoteRounded,
	CheckCircleRounded,
	BlockRounded,
} from '@mui/icons-material';
import { IRecursoRevision } from '../../../types/miRecurso';
import { StyledMenuItem, DangerMenuItem } from './styles';

interface ThreeDotMenuProps {
	recurso: IRecursoRevision;
	onDownload: (recurso: IRecursoRevision) => void;
	onSolicitarCambios: (recurso: IRecursoRevision) => void;
	onAprobar: (recurso: IRecursoRevision) => void;
	onDenegar: (recurso: IRecursoRevision) => void;
}

const ThreeDotMenu: React.FC<ThreeDotMenuProps> = ({
	recurso,
	onDownload,
	onSolicitarCambios,
	onAprobar,
	onDenegar,
}) => {
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
	const open = Boolean(anchorEl);

	const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
		event.stopPropagation();
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const handleAction = (action: (recurso: IRecursoRevision) => void) => {
		action(recurso);
		handleClose();
	};

	return (
		<>
			<IconButton size='small' onClick={handleOpen}>
				<MoreVertRounded fontSize='small' />
			</IconButton>

			<Menu
				anchorEl={anchorEl}
				open={open}
				onClose={handleClose}
				anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
				transformOrigin={{ vertical: 'top', horizontal: 'right' }}
				onClick={(e) => e.stopPropagation()}
			>
				<StyledMenuItem onClick={() => handleAction(onDownload)}>
					<ListItemIcon>
						<DownloadRounded fontSize='small' />
					</ListItemIcon>
					Descargar
				</StyledMenuItem>

				<StyledMenuItem onClick={() => handleAction(onSolicitarCambios)}>
					<ListItemIcon>
						<EditNoteRounded fontSize='small' />
					</ListItemIcon>
					Solicitar cambios
				</StyledMenuItem>

				<StyledMenuItem onClick={() => handleAction(onAprobar)}>
					<ListItemIcon>
						<CheckCircleRounded fontSize='small' color='success' />
					</ListItemIcon>
					Aprobar
				</StyledMenuItem>

				<DangerMenuItem onClick={() => handleAction(onDenegar)}>
					<ListItemIcon>
						<BlockRounded fontSize='small' />
					</ListItemIcon>
					Denegar
				</DangerMenuItem>
			</Menu>
		</>
	);
};

export default ThreeDotMenu;
